import type { AnalysisPromptType, SnapshotAnalysis } from '../types/snapshot';

export const getPromptType = (prompt: { prompt_type?: AnalysisPromptType | null }): AnalysisPromptType =>
  prompt.prompt_type === 'desk_occupancy' || prompt.prompt_type === 'desk_activity' ? prompt.prompt_type : 'generic';

export const getAnalysisStatus = (analysis?: Pick<SnapshotAnalysis, 'status' | 'analysis_status'> | null) =>
  analysis?.status ?? analysis?.analysis_status;

export const getAnalysisPromptType = (analysis?: Pick<SnapshotAnalysis, 'prompt_type' | 'detections'> | null): AnalysisPromptType => {
  if (analysis?.prompt_type) return analysis.prompt_type;
  if (Array.isArray(analysis?.detections)) {
    return analysis.detections.some(detection => detection.activity != null) ? 'desk_activity' : 'desk_occupancy';
  }
  return 'generic';
};
